// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"abfbdb97","239":"aacdd737","345":"af8359a4","388":"1ea36787","803":"a7bd6fa7"}[chunkId] + ".chunk.js";
};